export enum BUTTON_THEME_TYPES {
    PRIMARY = 'PRIMARY',
    PRIMARY_INVERSE = 'PRIMARY_INVERSE',
    DISABLED = 'DISABLED',
    WHITE = 'WHITE',
    WHITE_INVERSE = 'WHITE_INVERSE'
}

export enum BUTTON_THEME_STYLES {
    'PRIMARY' = 'bg-secondary text-white hover:bg-primary-dark',
    'PRIMARY_INVERSE' = 'bg-white text-black border border-secondary hover:bg-secondary-light',
    'DISABLED' = 'bg-none text-white border border-white hover:bg-white hover:text-primary',
    'WHITE' = 'bg-white text-primary border border-white hover:bg-primary hover:text-white',
    'WHITE_INVERSE' = 'bg-gray-300 text-gray-600 cursor-not-allowed',
}

export const buttonBaseStyles = 'py-0 px-4 text-sm text-center font-medium rounded-md transition duration-300 w-[175px] h-[35px] uppercase';